import React from 'react';
import { CheckCircle, Star, Shield, Clock } from 'lucide-react';
import { companyInfo } from '../mock';

const About = () => {
  const features = [
    {
      icon: Star,
      title: 'Unmatched Quality',
      description: 'Premium materials and master craftsmanship in every detail'
    },
    {
      icon: Shield,
      title: 'Full Transparency',
      description: 'Automated systems for real-time project monitoring and reporting'
    },
    {
      icon: Clock,
      title: 'On-Time Delivery',
      description: 'Structured processes ensuring timely project completion'
    },
    {
      icon: CheckCircle,
      title: 'Personalized Service',
      description: 'Dedicated team committed to bringing your vision to life'
    }
  ];

  const expertise = [
    'New Home Builds',
    'Luxury Renovations',
    'Duplex Construction',
    'Home Extensions',
    'Pool & Deck Installation',
    'Contemporary & Classic Designs'
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-[#c9a961]/10 text-[#c9a961] rounded-full text-sm font-semibold">
                About Us
              </span>
            </div>
            
            <h2
              className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Building Dreams for Over{' '}
              <span className="text-[#c9a961]">{companyInfo.experience} Years</span>
            </h2>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              {companyInfo.description}
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our commitment to excellence extends beyond construction. Whether building your dream home from the ground up, creating a modern duplex, renovating to luxury standards, extending your living space, or designing resort-style outdoor areas with custom pools and decks, we've developed proprietary project management systems that provide real-time updates and automated progress reporting, ensuring you're always informed and confident in your investment.
            </p>

            {/* Expertise Areas */}
            <div className="mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Our Expertise</h3>
              <div className="grid grid-cols-2 gap-3">
                {expertise.map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <CheckCircle className="h-5 w-5 text-[#c9a961] flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Features Grid */}
          <div className="grid sm:grid-cols-2 gap-6">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="bg-gradient-to-br from-[#faf8f5] to-[#f5f5f0] p-6 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="h-12 w-12 bg-white rounded-lg flex items-center justify-center mb-4 shadow-sm">
                    <Icon className="h-6 w-6 text-[#c9a961]" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;